/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_CompareInputs */

const en_control_compare = /** @type {(inputs: Control_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare options`)
};

const zh_control_compare = /** @type {(inputs: Control_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较选项`)
};

/**
* | output |
* | --- |
* | "Compare options" |
*
* @param {Control_CompareInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_compare = /** @type {((inputs?: Control_CompareInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_CompareInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_compare(inputs)
	return zh_control_compare(inputs)
});
export { control_compare as "control.compare" }